/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_APPLICATION_APPLY = gql`
  mutation candidateApplicationApply($applications: [CandidateApplicationApplyInput!]) {
    candidate {
      applications(apply: $applications) {
        applications {
          bearerToken
          id
        }
        errors
        validations
      }
    }
  }
`;

export const CANDIDATE_APPLICATION_FREE_FORM_APPLY = gql`
  mutation candidateApplicationFreeFormApply($applications: [CandidateApplicationFreeFormApplyInput!]) {
    candidate {
      applications(freeFormApply: $applications, persist: false) {
        applications {
          email
          msisdn
          firstName
          lastName
          education
          profileAttributes {
            key
            name
            value
          }
          insights {
            answerSuggestions
          }
        }
        errors
        validations
      }
    }
  }
`;
